export const UPDATE_DEVICES_ERROR_COUNT = 'UPDATE_DEVICES_ERROR_COUNT';
export const UPDATE_LOGIN = 'UPDATE_LOGIN';
export const UPDATE_USER_PERMISSIONS = 'UPDATE_USER_PERMISSIONS';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_LISTINGS = 'GET_LISTINGS';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const UPDATE_ORGANIZATION_TITLE = 'UPDATE_ORGANIZATION_TITLE';
export const UPDATE_ORGANIZATION_ID = 'UPDATE_ORGANIZATION_ID';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const ORG_MODAL = 'ORG_MODAL';
export const ENABLE_COLLECTIONS = 'ENABLE_COLLECTIONS';
export const CURRENT_ITEM_TITLE = "CURRENT_ITEM_TITLE";
export const UPDATE_MOBILE_STATE = 'UPDATE_MOBILE_STATE';
export const UPDATE_UNSAVED_DATA_STATE = 'UPDATE_UNSAVED_DATA_STATE';

export const updateDevicesErrorCount = count => {
    return {
        type: UPDATE_DEVICES_ERROR_COUNT,
        count
    }
}
/**
 * Update login status 
 * @param {*} isLoggedIn user information
 * @returns logged in user information 
 */
export const updateLoginStatus = isLoggedIn => {
    return {
        type: UPDATE_LOGIN,
        isLoggedIn
    }
}
/**
 * Update mobile state
 * @param {boolean} mobileMode mobileMode state
 * @returns mobileMode boolean
 */
export const updateMobileState = mobileMode => {
    return {
        type: UPDATE_MOBILE_STATE,
        mobileMode,
    }
}
/**
 * Update user permissions
 * @param {*} perms user permissions
 * @returns updated user permission
 */
export const updateUserPermissions = perms => {
    return {
        type: UPDATE_USER_PERMISSIONS,
        perms
    }
}
/**
 * Update current user
 * @param {*} user updated user information
 * @returns updated user information
 */
export const updateUser = user => {
    return {
        type: UPDATE_USER,
        user
    }
}
/** Update organization
 * @param {string} org organization name.
 * @returns new organization name 
 */
/** Set organization details (name, title, id) in one action
 * @param {{org:string, orgTitle:string, orgId:string|number}} payload
 * @returns combined organization details
 */
export const setOrganization = (payload) => {
    return {
        type: SET_ORGANIZATION,
        payload
    }
}
/** Open organization modal 
 * @returns organization state open 
*/
export const openOrganizationModal = name => {
    return {
        type: ORG_MODAL,
        show: name
    }
}
/** Close organization modal 
 * @returns organization state close 
*/
export const closeOrganizationModal = name =>{
    return {
        type: ORG_MODAL,
        show: name
    }
}
/** For set random delay  */
export const delay = async(ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export const updateUnsavedData = unsavedData => {
    return {
        type: UPDATE_UNSAVED_DATA_STATE,
        unsavedData,
    }
}
/** Enable collections feature
 * @param {boolean} enable enable collections feature
 * @returns collections feature state
 */
export const allowCollections = enable => {
    return {
        type: ENABLE_COLLECTIONS,
        enable
    }
}
